// src/components/common/UploadButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@/icons';
import LoadingButton from './LoadingButton';
import './UploadButton.css';

interface UploadButtonProps {
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  isLoading,
  onClick,
  disabled = false,
  className = '',
  label,
}) => {
  return (
    <LoadingButton
      isLoading={isLoading}
      onClick={onClick}
      disabled={disabled}
      className={`upload-button ${className}`}
    >
      <FontAwesomeIcon icon={faUpload} /> {label || 'Enviar'}
    </LoadingButton>
  );
};

export default UploadButton;
